import { render, staticRenderFns } from "./Cosmetics.vue?vue&type=template&id=14e9b33a&"
import script from "./Cosmetics.vue?vue&type=script&lang=js&"
export * from "./Cosmetics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports